<template>
    <student-backend-layout
        content-bg-color="gray-125"
        header-bg-color="gray-125"
    >
        <template #content>
            <div class="mx-auto mt-8 max-w-3xl bg-white shadow">
                <div class="p-6 font-semibold">Payment History</div>
                <div class="">
                    <div
                        v-if="invoices.length"
                        class="datatable-theme w-full overflow-x-scroll"
                    >
                        <easy-data-table
                            class="table"
                            :headers="headers"
                            :items="invoices"
                            :hide-footer="invoices.length <= 10"
                            :rows-per-page="10"
                            :rows-items="[10, 25, 50]"
                            buttons-pagination
                            empty-message="No invoices"
                            must-sort
                            alternating
                        >
                            <template #item-paid_at="invoice">
                                {{
                                    dayjs(invoice.paid_at)
                                        .utc(true)
                                        .tz($page.props.auth.user.timezone)
                                        .format(
                                            $page.props.date_formats.short_nice
                                        )
                                }}
                            </template>

                            <template #item-user.full_name="invoice">
                                <span class="whitespace-nowrap">
                                    {{ invoice.user.full_name }}
                                </span>
                            </template>
                            <template #item-subtotal="invoice">
                                <value-as-currency :value="invoice.subtotal" />
                            </template>
                            <template #item-discount_details="invoice">
                                <value-as-currency
                                    :value="invoice.discount_details.total"
                                />
                            </template>
                            <template #item-total="invoice">
                                <value-as-currency :value="invoice.total_usd" />
                            </template>
                            <template #item-actions="invoice">
                                <a
                                    class="ml-auto flex items-center justify-end gap-2 whitespace-nowrap text-primary-525 hover:cursor-pointer hover:text-primary-625"
                                    :href="
                                        route('show-invoice', {
                                            invoice_uuid: invoice.uuid,
                                        })
                                    "
                                    target="_blank"
                                >
                                    <div class="">Download Receipt</div>
                                    <div class="">
                                        <svg
                                            width="18"
                                            height="18"
                                            viewBox="0 0 18 18"
                                            fill="none"
                                            xmlns="http://www.w3.org/2000/svg"
                                        >
                                            <g
                                                clip-path="url(#clip0_1387_5050)"
                                            >
                                                <path
                                                    d="M6 12.75L9 15.75L12 12.75"
                                                    stroke="#0685BB"
                                                    stroke-width="1.5"
                                                    stroke-linecap="round"
                                                    stroke-linejoin="round"
                                                />
                                                <path
                                                    d="M9 9V15.75"
                                                    stroke="#0685BB"
                                                    stroke-width="1.5"
                                                    stroke-linecap="round"
                                                    stroke-linejoin="round"
                                                />
                                                <path
                                                    d="M15.66 13.5684C16.3121 13.1099 16.801 12.4555 17.056 11.7003C17.3109 10.945 17.3186 10.1282 17.0778 9.36829C16.837 8.6084 16.3604 7.94499 15.7171 7.47435C15.0737 7.0037 14.2971 6.7503 13.5 6.75093H12.555C12.3294 5.87183 11.9074 5.05536 11.3206 4.36299C10.7338 3.67061 9.99762 3.12037 9.16742 2.75369C8.33721 2.38701 7.43464 2.21345 6.52766 2.24606C5.62067 2.27868 4.7329 2.51663 3.93118 2.942C3.12946 3.36736 2.43468 3.96906 1.89915 4.7018C1.36362 5.43453 1.0013 6.27921 0.839456 7.17224C0.677613 8.06527 0.720468 8.98337 0.964796 9.85744C1.20912 10.7315 1.64856 11.5388 2.25001 12.2184"
                                                    stroke="#0685BB"
                                                    stroke-width="1.5"
                                                    stroke-linecap="round"
                                                    stroke-linejoin="round"
                                                />
                                            </g>
                                            <defs>
                                                <clipPath id="clip0_1387_5050">
                                                    <rect
                                                        width="18"
                                                        height="18"
                                                        fill="white"
                                                    />
                                                </clipPath>
                                            </defs>
                                        </svg>
                                    </div>
                                </a>
                            </template>
                        </easy-data-table>
                    </div>
                    <div
                        v-else
                        class="rounded border-gray-450 bg-gray-250 p-8 text-center"
                    >
                        <div class="mb-4 text-[18px] font-semibold">
                            No payments records available
                        </div>
                    </div>
                </div>
            </div>
        </template>
    </student-backend-layout>
</template>

<script>
import StudentBackendLayout from "@/_Layouts/NewStudentBackendLayout.vue";
import ValueAsCurrency from "@/Components/ValueAsCurrency.vue";

export default {
    name: "StudentManageSubscription",
    components: {
        ValueAsCurrency,
        StudentBackendLayout,
    },
    props: {
        invoices: {
            type: Array,
            default: [],
        },
    },
    data() {
        return {
            headers: [
                {
                    text: "Date Purchased",
                    value: "paid_at",
                },
                {
                    text: "Subtotal",
                    value: "subtotal",
                    class: "text-gray-750",
                },
                {
                    text: "Discount",
                    value: "discount_details",
                    class: "text-gray-750",
                },
                {
                    text: "Total",
                    value: "total",
                },
                {
                    text: "",
                    value: "actions",
                    sort: false,
                },
            ],
        };
    },
    methods: {},
};
</script>

<style lang="postcss" scoped>
.vue3-easy-data-table__header {
    th {
        @apply !bg-white !text-[14px] !text-gray-725;

        &:first-of-type {
            @apply pl-6;
        }

        &:last-of-type {
            @apply pr-6;
        }
    }
}

.vue3-easy-data-table__body {
    tr {
        @apply bg-gray-125;

        &.even-row {
            @apply bg-white;
        }

        td {
            @apply !px-4 !py-4;
        }

        td:first-of-type {
            @apply !pl-6;
        }

        td:last-of-type {
            @apply !pr-6;
        }
    }
}
</style>
